export async function uploadToBlob(content, fileName, projectId) {
  const containerName = sessionStorage.getItem('containerName');

  if (!containerName) {
    throw new Error('Container name not found');
  }

  const blobPath = `${projectId}/${fileName}`;

  const response = await fetch('/api/uploadBlob', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      fileName: blobPath,
      content,
      container: containerName
    })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.details || 'Failed to upload file');
  }
}

export async function downloadFromBlob(fileName, projectId) {
  const containerName = sessionStorage.getItem('containerName');

  if (!containerName) {
    throw new Error('Container name not found');
  }

  const blobPath = `${projectId}/${fileName}`;

  const response = await fetch(`/api/downloadBlob?fileName=${encodeURIComponent(blobPath)}&container=${encodeURIComponent(containerName)}`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.details || 'Failed to download file');
  }

  const { content } = await response.json();
  return content;
} 